import { Typography, Button } from '@tunasong/ui-lib'
import { graphHooks } from '@tunasong/graph-lib/react'
import type { Persisted, Poll } from '@tunasong/schemas'
import { isManyOfManyPoll, isOneOfManyPoll, isPersisted, isPoll } from '@tunasong/schemas'
import type { FC } from 'react'
import { useState } from 'react'
import invariant from 'tiny-invariant'
import { ManyOfManyPollFinal } from '../many-of-many/final.js'
import { OneOfManyPollFinal } from '../one-of-many/final.js'
import type { PollViewProps } from './types.js'
import styles from './final-option.module.css'

const ResponsesView: FC<PollViewProps> = props => {
  const { entity: poll } = props

  const updateEntity = graphHooks.useEntityUpdate<Poll>({ debounceDelay: 0 })

  const [final, setFinal] = useState<Persisted<Poll>>(poll)

  /** We use a dummy userId for the final option */
  const userId = 'final'

  const handleChange = (updatedPoll: Persisted<Poll>) => {
    setFinal(updatedPoll)
  }
  const handleComplete = () => {
    invariant(isPersisted(final), `handleComplete for non-persisted entity: ${JSON.stringify(final)}`)
    setFinal({ ...final, closed: true })
    updateEntity(final.id, { ...final, closed: true })
  }

  if (!isPoll(final)) {
    return null
  }

  const completeDisabled = poll.closed || typeof final.finalOption === 'undefined'

  const title = poll.closed ? 'Final Results' : 'Finalize Poll'
  return (
    <>
      <Typography variant="h2" gutterBottom>
        {title}
      </Typography>
      <div className={styles.content}>
        {isManyOfManyPoll(final) ? (
          <ManyOfManyPollFinal poll={final} userId={userId} onChange={handleChange} sort={false} />
        ) : null}
        {isOneOfManyPoll(final) ? (
          <OneOfManyPollFinal poll={final} userId={userId} onChange={handleChange} sort={false} />
        ) : null}
      </div>

      {!final.closed ? (
        <Button
          variant="outlined"
          color="secondary"
          disabled={completeDisabled}
          onClick={handleComplete}
          className={styles.completeButton}
        >
          Select final option(s)
        </Button>
      ) : null}
    </>
  )
}

export default ResponsesView
